import {useMemo} from 'react';
import {getDateFormat, getHourMinutes} from '../../../library/dates';
import {TTimetableItem} from '../../../redux/timetable/timetable.type';

const formatTime = (timestamp: number) => getHourMinutes(timestamp);
const getDayKey = (timestamp: number) => getDateFormat(timestamp, 'YYYY-M-D');

type ConferenceDay = {key: string; label: string; timestamp: number};

export function useTimeGroups(lectures: TTimetableItem[], currentDay: ConferenceDay | undefined) {
    return useMemo(() => {
        const filtered = currentDay
            ? lectures.filter(l => getDayKey(l.time) === currentDay.key)
            : lectures;

        const lectureItems: TTimetableItem[] = [];
        const breakItems: TTimetableItem[] = [];
        for(const item of filtered) {
            (item.isBreak ? breakItems : lectureItems).push(item);
        }

        const groupsMap = new Map<string, {time: string; rawTime: number; tsid: number | null; lectures: TTimetableItem[]}>();
        for(const lecture of lectureItems) {
            const groupKey =  `s:${lecture.tsid}` ;
            const group = groupsMap.get(groupKey) ?? {time: formatTime(lecture.time), rawTime: lecture.time, tsid: lecture.tsid ?? null, lectures: []};
            group.lectures.push(lecture);
            groupsMap.set(groupKey, group);
        }
        const grouped = Array.from(groupsMap.values());

        const breakGroups = breakItems.map(b => ({
            time: formatTime(b.time),
            rawTime: b.time,
            isBreak: true as const,
            breakItem: b,
        }));

        return [...grouped, ...breakGroups].sort((a, b) => a.rawTime - b.rawTime);
    }, [lectures, currentDay]);
}
